module.exports = __webpack_public_path__ + "img/world3.9a905252.png";